import { USER_ALERT_DISPLAY } from '../constants/admin'

export const INVITES_CLEAR = 'invites/CLEAR'
export const INVITES_CREATE = 'invites/CREATE'
export const INVITES_CREATE_SUCCESS = 'invites/CREATE_SUCCESS'
export const INVITES_CREATE_FAILURE = 'invites/CREATE_FAILURE'
export const INVITES_REMOVE = 'invites/REMOVE'
export const INVITES_REMOVE_SUCCESS = 'invites/REMOVE_SUCCESS'
export const INVITES_REMOVE_FAILURE = 'invites/REMOVE_FAILURE'
export const INVITES_FETCH = 'invites/FETCH'
export const INVITES_FETCH_SUCCESS = 'invites/FETCH_SUCCESS'
export const INVITES_FETCH_FAILURE = 'invites/FETCH_FAILURE'

export const clear = () => ({
  type: INVITES_CLEAR
})

export const create = value => {
    return {
        type: INVITES_CREATE,
        value
    };
};

export const createSuccess = data => {
    return {
        type: INVITES_CREATE_SUCCESS,
        value: data
    };
};

export const createFailure = error => {
    return {
        type: INVITES_FETCH_FAILURE,
        value: error
    };
};

export const fetch = params => {
    return {
        type: INVITES_FETCH,
        value: {
            params
        }
    };
};

export const fetchSuccess = data => {
    return {
        type: INVITES_FETCH_SUCCESS,
        value: data
    };
};

export const fetchFailure = error => {
    return {
        type: INVITES_FETCH_FAILURE,
        value: error
    };
};

export const remove = params => {
    return {
        type: INVITES_REMOVE,
        value: {
            params
        }
    };
};

export const removeSuccess = data => {
    return {
        type: INVITES_REMOVE_SUCCESS,
        value: data
    };
};

export const removeFailure = error => {
    return {
        type: INVITES_REMOVE_FAILURE,
        value: error
    };
};

export const setAlert = params => {
    return {
        type: USER_ALERT_DISPLAY,
        payload: params
    }
}